module.exports = __webpack_public_path__ + "img/stock0.90f82eb2.png";